import { render, staticRenderFns } from "./MigrationAlertUpgradePlan.vue?vue&type=template&id=7472760e"
import script from "./MigrationAlertUpgradePlan.vue?vue&type=script&lang=js"
export * from "./MigrationAlertUpgradePlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports